import { memo, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import { ChartStatus, useChartsContext } from "contexts/ChartContext";
import { updateChartByPath } from "store/features";
import { RootState } from "store/rootReducer";
import { allTrue, anyTrue } from "utils/fp";

import { useChartEntities } from "hooks/charts";

import LassoIcon from "components/icons/Lasso";

import ToolbarButton from "../../../base/ToolbarButton";

export const LASSO_SELECTION_LABEL = "Lasso Selection";

function LassoBrush() {
  const { id, status } = useChartsContext();
  const dispatch = useDispatch();
  const { lasso: lassoState, multiProduct } = useChartEntities(id);
  const isFiltering = useSelector((state: RootState) => state.filter.isFiltering);

  const isActive = allTrue(lassoState.active);
  const isDisabled = anyTrue(
    !lassoState.enabled,
    isFiltering,
    status === ChartStatus.Loading,
    multiProduct?.active
  );
  const showButton = lassoState?.show;
  const handleLassoToggle = (visible: boolean) => {
    dispatch(
      updateChartByPath({
        id,
        path: `features.lasso.active`,
        value: visible
      })
    );
  };

  useEffect(() => {
    if (status === ChartStatus.Loading || status === ChartStatus.Error) {
      handleLassoToggle(false);
    }
  }, [status]);

  if (!showButton) {
    return null;
  }

  return (
    <ToolbarButton
      icon={<LassoIcon />}
      active={isActive}
      disabled={isDisabled}
      overflowLabel={LASSO_SELECTION_LABEL}
      tooltipText={LASSO_SELECTION_LABEL}
      data-testid="lasso-toggle"
      onToggle={handleLassoToggle}
    />
  );
}

export default memo(LassoBrush);
